import * as React from "react";
import { CalcRequestValue } from "../../../../../application/domain/payment/calc-request";
import { PaymentItemTable } from "./payment-item-table";
import { CalculateResult } from "./calculate-result";
import { RequestPaymentWarningMessages } from "./request-payment-warning-messages";
import { PaymentCalcState, PaymentCalculateResult } from "./hooks";
import classNames from "classnames";
import { useState } from "react";
import { CharCount } from "../../../../molecules/char-count";
import {
  PaymentConst,
  PaymentMethod,
  PaymentMethodUILabel,
} from "@graffer-inc/cloud-gov-core";
import { Checkbox } from "@graffer-inc/console-design-kit";

type RequestPaymentProps = {
  orgAcceptedPaymentMethods?: PaymentMethod[];
  isAcceptMultiMethodsOrg: boolean;
  calcRequest: CalcRequestValue;
  setCalcRequest: (value: CalcRequestValue) => void;
  paymentResult: PaymentCalculateResult;
  paymentCalcState: PaymentCalcState;
};

export const RequestPayment: React.FC<RequestPaymentProps> = ({
  orgAcceptedPaymentMethods = ["credit_card"],
  isAcceptMultiMethodsOrg,
  calcRequest,
  setCalcRequest,
  paymentResult,
  paymentCalcState,
}) => {
  const [messageTouched, setMessageTouched] = useState(false);

  const onToggleTarget = React.useCallback(
    (toggled: PaymentMethod) => {
      calcRequest.updateAcceptedPaymentMethods(
        calcRequest.getValue().acceptedPaymentMethods.includes(toggled)
          ? calcRequest
              .getValue()
              .acceptedPaymentMethods.filter((t) => t !== toggled)
          : [...calcRequest.getValue().acceptedPaymentMethods, toggled],
      );
      setCalcRequest(calcRequest.copy());
    },
    [calcRequest, orgAcceptedPaymentMethods],
  );

  const options = React.useMemo(
    () =>
      orgAcceptedPaymentMethods.map((acceptMethod) => ({
        name: PaymentMethodUILabel[acceptMethod],
        value: acceptMethod,
      })),
    [orgAcceptedPaymentMethods],
  );
  return (
    <>
      <PaymentItemTable calcRequest={calcRequest} onChange={setCalcRequest} />
      <CalculateResult state={paymentCalcState} paymentResult={paymentResult} />
      {isAcceptMultiMethodsOrg && (
        <div className="mt-6 mb-3">
          <div className="field">
            <Checkbox
              values={calcRequest.getValue().acceptedPaymentMethods}
              onChange={(v) => {
                onToggleTarget(v.target.value as PaymentMethod);
              }}
              options={options}
              label={"支払い手段"}
              description={"支払い手段を選択してください。"}
              errorMessages={
                calcRequest.acceptedPaymentMethodsError()
                  ? calcRequest.acceptedPaymentMethodsError()
                  : undefined
              }
              required
            />

            <RequestPaymentWarningMessages
              calcRequest={calcRequest}
              paymentAmount={paymentResult.payment?.amount}
            />
          </div>
        </div>
      )}
      <div className="field">
        <label className="label">申請者へのメッセージ</label>
        <textarea
          className={classNames("textarea", {
            "is-danger": !!calcRequest.messageError() && messageTouched,
          })}
          placeholder="自動通知メールで申請者に依頼内容が通知されます。"
          value={calcRequest.getValue().message}
          onBlur={() => setMessageTouched(true)}
          onChange={(e) => {
            calcRequest.updateMessage(e.target.value);
            setCalcRequest(calcRequest.copy());
          }}
        />
        <div className="level">
          <div className="level-left">
            {!!calcRequest.messageError() && (
              <p className="help is-danger">{calcRequest.messageError()}</p>
            )}
          </div>
          <div className="level-right">
            <CharCount
              text={calcRequest.getValue().message}
              maxLength={PaymentConst.MAX_PAYMENT_MESSAGE_LENGTH}
            />
          </div>
        </div>
      </div>
    </>
  );
};
